import axios from 'axios';

export default () => {
  const ax = axios.create({
    baseURL: '/api/',
    method: 'GET',
    responseType: 'blob', // Needed for binary file download.
  });

  ax.interceptors.request.use(
    (reqConfig) => {
      reqConfig.headers.authorization = `Bearer ${localStorage.getItem('access_token')}`; // eslint-disable-line no-param-reassign
      return reqConfig;
    },
    (err) => Promise.reject(err),
  );

  return ax;
};
